// extracted by mini-css-extract-plugin
export default {"dialog":"BulkVersioningDialog_dialog__TCwRz","content":"BulkVersioningDialog_content__50RW-"};